exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".moving-arrow{border-right:17px solid #f4f3ef;border-top:17px solid transparent;border-bottom:17px solid transparent;display:inline-block;position:absolute;left:243px;top:95px;transition:all .5s cubic-bezier(.29,1.42,.79,1)}@media (max-width:992px){.moving-arrow{display:none}}", ""]);

